export class ChargingMethodologyModel {

  value: string;

  constructor(value?: string) {
    this.value = value;
  }
}
